import PaymentSpeedSelect, { PaymentSpeedInputProps } from "./PaymentSpeedSelect";

// Note: BrokerProvider should be at page level, not here
// This allows defaultPaymentSettings to be shared across components
export default function PaymentSpeedInput(props: PaymentSpeedInputProps) {
  return <PaymentSpeedSelect {...props} />;
}
